import CheckRounded from '@mui/icons-material/CheckRounded'
import { Box, Step, StepConnector, stepConnectorClasses, StepIconProps, StepLabel, Stepper as MuiStepper, styled } from '@mui/material'
import React from 'react'
import { black, greyEnabled, purple, purpleLight } from '../../../../theme/colors'

const Connector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 16,
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderTopWidth: 2,
        borderColor: '#EAEAEA',
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}, &.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        borderColor: purple,
    },
}))

function StepCircle({ active, completed, icon }: StepIconProps) {
    return (
        <Box
            sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
                fontWeight: 700,
                bgcolor: active || completed ? purple : purpleLight,
                color: active || completed ? '#FFFFFF' : greyEnabled,
                transition: 'background-color 0.2s ease, color 0.2s ease',
            }}
        >
            {completed ? <CheckRounded sx={{ fontSize: 18 }} /> : icon}
        </Box>
    )
}

export default function Steppe({ stepperData, stepperCount }:
    {
        stepperData: {
            id: number,
            name: string
        }[],
        stepperCount: number,
        setStepperCount: (val: number) => void
    }) {
    const activeIndex = stepperData.findIndex((item) => item.id === stepperCount)

    return (
        <MuiStepper activeStep={activeIndex} alternativeLabel connector={<Connector />}>
            {stepperData.map((item) => (
                <Step key={item.id}>
                    <StepLabel
                        StepIconComponent={StepCircle}
                        sx={{
                            '& .MuiStepLabel-label': {
                                mt: 1,
                                fontSize: 13,
                                fontWeight: 600,
                                color: greyEnabled,
                            },
                            '& .MuiStepLabel-label.Mui-active, & .MuiStepLabel-label.Mui-completed': {
                                color: black,
                            },
                        }}
                    >
                        {item.name}
                    </StepLabel>
                </Step>
            ))}
        </MuiStepper>
    )
}
